var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.563 2.5h-3.438v-.625C13.125.839 12.285 0 11.25 0h-2.5C7.714 0 6.875.84 6.875 1.875V2.5H3.437c-.862 0-1.562.7-1.562 1.562v1.25c0 .346.28.625.625.625h15c.345 0 .625-.28.625-.625v-1.25c0-.862-.7-1.562-1.563-1.562zm-8.438-.625c0-.345.28-.625.625-.625h2.5c.345 0 .625.28.625.625V2.5h-3.75v-.625zM3.06 7.188c-.111 0-.2.093-.195.204l.516 10.822A1.873 1.873 0 005.254 20h9.491a1.873 1.873 0 001.873-1.786l.515-10.822a.195.195 0 00-.195-.205H3.061zM12.5 8.75a.625.625 0 111.25 0v8.125a.625.625 0 11-1.25 0V8.75zm-3.126 0a.625.625 0 111.25 0v8.125a.625.625 0 11-1.25 0V8.75zm-3.125 0a.625.625 0 111.25 0v8.125a.625.625 0 11-1.25 0V8.75z"
  })));
}

export default SvgDelete;